import React from 'react';
import {
  Box, Chip, InputAdornment, Stack, Tab, Tabs, TextField,
} from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

export const DEFAULT_RECOMMENDATION_GROUPS = ['all', 'scope1', 'scope2', 'scope3'];

/** Scope/search controls with read-visible deep-link context kept below the search field. */
export default function RecommendationToolbar({
  contextChips = [],
  groups = DEFAULT_RECOMMENDATION_GROUPS,
  onClearContext,
  onGroupChange,
  onSearchChange,
  searchValue = '',
  selectedGroup = 'all',
  t,
}) {
  return (
    <Stack spacing={1.25} sx={{ mt: 1.25 }}>
      <Box sx={{
        alignItems: 'center', display: 'grid', gap: 1.5,
        gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 1fr) minmax(260px, 0.48fr)' },
      }}>
        <Tabs
          aria-label={t('climateAction.ai.title')}
          onChange={(event, value) => onGroupChange?.(value)}
          scrollButtons={false}
          value={selectedGroup}
          variant={'scrollable'}
          sx={{ minHeight: 40, '& .MuiTab-root': { minHeight: 40, py: 0.75 } }}
        >
          {groups.map(group => (
            <Tab key={group} label={t(`climateAction.ai.group.${group}`)} value={group} />
          ))}
        </Tabs>

        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position={'start'}>
                <SearchRoundedIcon color={'action'} fontSize={'small'} />
              </InputAdornment>
            ),
          }}
          fullWidth
          inputProps={{
            'aria-label': t('climateAction.ai.searchPlaceholder'),
          }}
          onChange={event => onSearchChange?.(event.target.value)}
          placeholder={t('climateAction.ai.searchPlaceholder')}
          size={'small'}
          value={searchValue}
        />
      </Box>

      {contextChips.length > 0 && (
        <Stack
          data-testid={'recommendation-context-chips'}
          direction={'row'}
          spacing={0.75}
          useFlexGap
          flexWrap={'wrap'}
        >
          {contextChips.map((context, index) => {
            const item = typeof context === 'string'
              ? { id: context, label: context }
              : context;
            return (
              <Chip
                color={item.color || 'info'}
                key={item.id || item.label || index}
                label={item.label}
                onDelete={item.clearable === false
                  ? undefined
                  : () => (item.onClear || onClearContext)?.(item)}
                variant={item.variant || 'outlined'}
              />
            );
          })}
        </Stack>
      )}
    </Stack>
  );
}
